export default {"src":"/komodo/_next/static/media/pol.9dd45e11.svg","height":34,"width":89,"blurWidth":0,"blurHeight":0};